import { postJson, withDone, withValidate } from '@rad/utility/http';
export const login = (email) => withDone(withValidate(postJson('/api/login', { email })))();
